import { differenceInCalendarDays } from "date-fns";
import type { TimelineItemResponseDTO as TimelineItem } from "web_myplann/Infrastructure/Api/Api";
import { parseTimelineDate } from "web_myplann/NotificationCenter/Utils/parseTimelineDate";

export type UpcomingBucketKey =
	| "in7days"
	| "in14days"
	| "in30days"
	| "in3months"
	| "in6months"
	| "in12months";

const BUCKETS: ReadonlyArray<{ maxDays: number; key: UpcomingBucketKey }> = [
	{ maxDays: 7, key: "in7days" },
	{ maxDays: 14, key: "in14days" },
	{ maxDays: 30, key: "in30days" },
	{ maxDays: 90, key: "in3months" },
	{ maxDays: 180, key: "in6months" },
	{ maxDays: 365, key: "in12months" },
];

export const computeTimeBuckets = (
	item: TimelineItem,
	today: Date,
): UpcomingBucketKey | null => {
	const diff = differenceInCalendarDays(parseTimelineDate(item.date), today);
	if (diff < 0) return null;
	return BUCKETS.find((b) => diff <= b.maxDays)?.key ?? null;
};
